<script lang="ts">
  import { errorComponent } from "@kestrel/client";
  import type { ProblemJson } from "@kestrel/http";
  import { setContext, type Component as ComponentType } from "svelte";
  import type { FormActions, FormResult } from "@kestrel/actions";
  import type { LoadResult } from "@kestrel/server";
  import { writable } from "svelte/store";
  import type { KestrelStores } from "@kestrel/stores";

  const {
    component: Component,
    data,
    form,
    error,
    routeId,
  }: {
    component?: ComponentType<any, any>;
    data?: LoadResult<(...args: any[]) => any>;
    form?: FormResult<FormActions>;
    error?: ProblemJson;
    routeId: string;
  } = $props();

  const dataStore = writable(data);
  const formStore = writable(form);
  const errorStore = writable(error);
  const routeIdStore = writable(routeId);

  setContext<KestrelStores>("__kestrel__", {
    data: dataStore,
    form: formStore,
    error: errorStore,
    routeId: routeIdStore,
  });
</script>

{#if $errorStore}
  {#await errorComponent() then { default: ErrorComponent }}
    <ErrorComponent error={$errorStore} />
  {/await}
{:else}
  <Component data={$dataStore} form={$formStore} />
{/if}
